import { render, staticRenderFns } from "./AutoTraderDealModal.vue?vue&type=template&id=686c0840&scoped=true"
import script from "./AutoTraderDealModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoTraderDealModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AutoTraderDealModal.vue?vue&type=style&index=0&id=686c0840&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686c0840",
  null
  
)

export default component.exports